// modulo  paginator
// https://github.com/cornflourblue/react-pagination-example
// Css bootstrap https://stackpath.bootstrapcdn.com/bootstrap/3.4.1/css/bootstrap.min.css
import React from 'react';

class AccordionBlock extends React.Component {



    constructor(props) {
        super(props);
        this.state = { };

        this.toggleOpenBlcok =this.toggleOpenBlcok.bind(this);

    }
    componentDidMount() { }
    toggleOpenBlcok(e){

     /*   let accordion = e.target.querySelector('.accordion-block');
        e.target.parentNode.querySelector('.accordion-body')
        debugger;*/
        let accordionBody = e.target.parentNode.querySelector('.accordion-body');
        let button = e.target;
        if( accordionBody.classList  == 'accordion-body open' ) {
            accordionBody.classList.remove('open')
            button.textContent="+";
        }else{
            accordionBody.classList.add('open')
            button.textContent="-";
        }console.log(e.target.classList)
    }
    render() {
        const stylesBlock = {
            accordionBlock:{
                "backgroundColor": "#f3f3f3"
            },
            accTitle:{
                "fontWeight":"bold",
                "color":"#111111",
                "fontSize":"22px"
            }
        }
        return (
            <div id={'accordion-block'}  style={stylesBlock.accordionBlock}>
                <h2 className={'acc-title'} style={ stylesBlock.accTitle }>
                    { this.props.titleAccordion }
                </h2>
                <p className={'accordion-body'}  >
                    { this.props.bodyAccordion }
                </p>
                <button className={'acc-btn'}  onClick={ (e) => this.toggleOpenBlcok(e) }>
                         +
                </button>

            </div>
        );
    }
}

export default AccordionBlock;